// src/components/Sidebar.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Sidebar({ role }) {
  return (
    <div className="vh-100 p-2">
      <ul className="list-group list-group-flush">

        {/* Dashboard → IT Admin only */}
        {role === "it_admin" && (
          <li className="list-group-item">
            <Link to="/dashboard" className="text-decoration-none">
              Dashboard
            </Link>
          </li>
        )}

        {/* Users → IT Admin only */}
        {role === "it_admin" && (
          <li className="list-group-item">
            <Link to="/dashboard/users" className="text-decoration-none">
              Users
            </Link>
          </li>
        )}

        {/* AI Recordings → All */}
        <li className="list-group-item">
          <Link to="/dashboard/ai-recordings" className="text-decoration-none">
            AI Recordings
          </Link>
        </li>

      </ul>
    </div>
  );
}